import { PlusOutlined } from "@ant-design/icons";
import { Col, Form, Row, Space, Typography } from "antd";
import Card from "features/Cart/components/Card";
import { COMBO_CAMPAIGN, DISCOUNT_TYPE, TYPE_LIMIT } from "features/Campaign/constants";
import { t } from "i18next";
import { useState } from "react";
import ComboDiscountForm from "../components/ComboDiscountForm";

import ImportExcelModal from "../components/ImportExcelModal";

function DiscountMoneyForm({
  handleRemoveValueComboSelected,
  form,
  promotionCampaignTiers,
  indexErrorCombo,
  isUpdate,
  initFormDiscountMoney,
  dataTiersServer: initialDataTiersServer,
  onGetDataDiscountMoney,
}) {
  const [dataTiersServer, setDataTiersServer] = useState(initialDataTiersServer || []);

  const handleImportSuccess = (tierGroups) => {
    if (tierGroups && tierGroups.length > 0) {
      const convertedTierGroups = tierGroups.map((tierGroup) => {
        const convertedTiers = tierGroup?.promotionCampaignTiers?.map((tier) => {
          const maxQuantity = tier?.maxQuantityPerSeller || 0;
          const limitType = maxQuantity > 0 ? TYPE_LIMIT.LIMIT : TYPE_LIMIT.NO_LIMIT;

          return {
            type: COMBO_CAMPAIGN.DISCOUNT_MONEY,
            minQuantity: tier?.minQuantity || null,
            maxQuantityPerSeller: maxQuantity > 0 ? maxQuantity : null,
            discountType: tier?.discountType || DISCOUNT_TYPE.DISCOUNT_MONEY,
            discountAmount: tier?.discountAmount || null,
            budgetAmount: tier?.budgetAmount || null,
            limitType: limitType,
            conditionProductGroups:
              tier?.conditionProductGroups?.length > 0
                ? tier.conditionProductGroups.map((group) => ({
                    quantity: group?.quantity || 1,
                    conditionPromotionProducts: group?.conditionPromotionProducts
                      ?.filter((prod) => prod?.productID || prod?.id || prod?.product?.id)
                      .map((prod) => {
                        const productId = prod?.productID || prod?.id || prod?.product?.id;
                        return {
                          productID: productId,
                          product: prod?.product?.id ? prod?.product : { ...prod?.product, id: productId },
                        };
                      }),
                  }))
                : [{ quantity: 1, conditionPromotionProducts: [] }],
          };
        });

        return {
          type: COMBO_CAMPAIGN.DISCOUNT_MONEY,
          promotionCampaignTiers: convertedTiers,
        };
      });

      // Get existing data from form
      const existingData = form.getFieldValue("promotionCampaignTierGroupsDiscountMoney") || [];

      // Check if existing combos are empty (no products selected)
      const hasEmptyCombos = existingData.some(
        (combo) => !combo?.promotionCampaignTiers?.[0]?.conditionProductGroups?.[0]?.conditionPromotionProducts?.length
      );

      // If there are empty combos, replace them with imported data
      // Otherwise, append imported data to existing data
      const mergedData = hasEmptyCombos ? convertedTierGroups : [...existingData, ...convertedTierGroups];

      form.setFieldsValue({
        promotionCampaignTierGroupsDiscountMoney: mergedData,
      });

      setDataTiersServer(mergedData);
      onGetDataDiscountMoney && onGetDataDiscountMoney(mergedData);
    }
  };

  return (
    <Card
      title={
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
          <Typography.Title level={5} style={{ textTransform: "uppercase", margin: 0 }}>
            {t("campaign.combo.comboDiscount")}
          </Typography.Title>
          <div onClick={(e) => e.stopPropagation()}>
            <ImportExcelModal
              campaignType="DISCOUNT_MONEY"
              onImportSuccess={handleImportSuccess}
              title="Upload file thông tin khuyến mãi combo giảm tiền"
            />
          </div>
        </div>
      }
    >
      <Space
        direction="vertical"
        style={{
          width: "100%",
        }}
      >
        <Typography.Text italic className="title-main">
          {t("campaign.combo.noteComboDiscount")}
        </Typography.Text>
        <Form.List name={"promotionCampaignTierGroupsDiscountMoney"}>
          {(fields, { add, remove }) => {
            const handleAddComboCollapse = () => {
              add(initFormDiscountMoney);
            };

            return (
              <Row gutter={[16, 16]}>
                {fields.map((field, index) => (
                  <Col span={24} key={field.key}>
                    <ComboDiscountForm
                      onRemoveValueComboSelected={handleRemoveValueComboSelected}
                      form={form}
                      remove={() => remove(field.name)}
                      promotionCampaignTiers={promotionCampaignTiers}
                      indexErrorCombo={indexErrorCombo}
                      isUpdate={isUpdate}
                      indexComboDiscount={index}
                      dataTiersServer={dataTiersServer}
                      onGetDataDiscountMoney={onGetDataDiscountMoney}
                    />
                  </Col>
                ))}
                <Col span={24}>
                  <Typography.Link underline onClick={() => handleAddComboCollapse()}>
                    <PlusOutlined /> {t("campaign.combo.addComboDiscountMoney")}
                  </Typography.Link>
                </Col>
              </Row>
            );
          }}
        </Form.List>
      </Space>
    </Card>
  );
}

export default DiscountMoneyForm;
